import { ALL_DAYS, WEEKDAYS, WEEKDAYS_ID, WEEKENDS } from '../../../const';

export default [
  {
    id: '4760ff1b-41f2-4450-8bf4-83dc7384b594',
    questionOrder: 4,
    readableId: WEEKDAYS_ID,
    type: 'multi_optional',
    title: 'When do you want to play?',
    helpText: 'Decide between weekdays, weekends and anytime.',
    answers: {
      mandatory: [
        {
          answerId: 1,
          analyticsId: 'alldays',
          title: 'All days',
          answerType: 'basic',
          value: ALL_DAYS,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '191d8b36-171e-4227-836f-58a0b597744a',
            },
          ],
        },
        {
          answerId: 2,
          analyticsId: 'weekdays',
          title: 'Weekdays',
          answerType: 'basic',
          value: WEEKDAYS,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '191d8b36-171e-4227-836f-58a0b597744a',
            },
          ],
        },
        {
          answerId: 3,
          analyticsId: 'weekends',
          title: 'Weekends',
          answerType: 'basic',
          value: WEEKENDS,
          ageRanges: [
            {
              min: 0,
              max: 0,
              nextQuestionId: '191d8b36-171e-4227-836f-58a0b597744a',
            },
          ],
        },
      ],
    },
  },
];
